import * as React from 'react';

import ToolTip, { ToolTipProps } from './ToolTip';

type WithTooltipProps = Omit<ToolTipProps, 'targetRef'> & {
  children: React.ReactNode;
  className?: string;
  /** показывается ли тултип при наведении */
  show?: boolean;
  Element?: React.ElementType;
};

const WithTooltip: React.FC<WithTooltipProps> = ({ Element = 'div', className, children, show = true, ...props }) => {
  const targetRef = React.useRef<any>();

  return (
    <>
      <Element className={className} ref={targetRef}>
        {children}
      </Element>
      {show && <ToolTip {...props} targetRef={targetRef} />}
    </>
  );
};

export default WithTooltip;
